// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manageDetail[data-v-34426941] .el-drawer__header{margin-bottom:0}.manageDetail[data-v-34426941] .el-drawer__body{padding-top:0}", ""]);
// Exports
module.exports = exports;
